import { Container, Grid, Button, Box, Alert, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { TABLE_HEAD_SWAP_REBALANCE_ITEMS } from "../../../../component/Methods";
import { useSelector } from "react-redux";

import SwapRebalanceItems from "../../Components/SwapRebalanceItems";
import SwapRebalanceFinalSkeleton from "../../Skeletons/SwapRebalanceFinalSkeleton";
import { selectSwapFinalStrategies, selectActiveRequests } from "../../../../Redux/Reducers/selectors";
const SwapStep3 = ({ setCurrentStep, contracts }) => {
  const swapFinalStrategies = useSelector(selectSwapFinalStrategies);
  const activeRequests = useSelector(selectActiveRequests);
  const [selectedContract, setSelectedContract] = useState("all");
  const [filteredContracts, setFilteredContracts] = useState([]);
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    if (swapFinalStrategies) {
      setFilteredContracts(swapFinalStrategies);
    }
  }, []);

  useEffect(() => {
    if (selectedContract === "all") {
      setFilteredContracts(swapFinalStrategies || []);
    } else {
      const filtered =
        swapFinalStrategies?.filter(
          (contract) => contract.id === selectedContract
        ) || [];
      setFilteredContracts(filtered);
    }
  }, [selectedContract, swapFinalStrategies]);

  useEffect(() => {
    const hasErrors = swapFinalStrategies?.every(
      (contract) => contract.validationErrors?.length > 0
    );
    setHasValidationErrors(hasErrors);
    const allSuccessful = swapFinalStrategies?.every(
      (contract) => contract.success === true
    );
    setShowSuccessMessage(!hasValidationErrors && allSuccessful);
  }, [swapFinalStrategies]);
  const isLoadingBlacklistedData = activeRequests.includes("rebalance_swaps");

  if (isLoadingBlacklistedData) {
    return < SwapRebalanceFinalSkeleton/>;
  }

  return (
    <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box sx={{ width: "40%" }}>
              <Box
                sx={{
                  marginBottom: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                  Submitted Contracts
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <select
                    value={selectedContract}
                    onChange={(e) => setSelectedContract(e.target.value)}
                    style={{
                      padding: "5px",
                      fontSize: "14px",
                      marginBottom: 10,
                    }}
                    size="small"
                  >
                    <option value="all">All</option>
                    {swapFinalStrategies?.map((contract) => (
                      <option key={contract.id} value={contract.id}>
                        {contract.name}
                      </option>
                    ))}
                  </select>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          {showSuccessMessage && (
            <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
              Rebalance request submitted, you will be notified via email once
              its completed.
            </Alert>
          )}
          {!showSuccessMessage && filteredContracts?.length > 0 && (
            <>
              <Box sx={{ display: "flex", flexDirection: "row", width: "60%" }}>
                <SwapRebalanceItems
                  filteredContracts={filteredContracts}
                  tableHeader={TABLE_HEAD_SWAP_REBALANCE_ITEMS}
                  hasValidationErrors={hasValidationErrors}
                  filteredStrategies={false}
                />
              </Box>
            </>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default SwapStep3;
